import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import { scrollToAnchor } from 'Utils/view';
import vue3RouteList from '@/../prerender/excluded-routes.json';

function getLinks(el) {
  const all = Array.from(el.querySelectorAll('a:not([improved])'));
  const external = [];
  const internal = [];
  all.forEach((link) => {
    // If hostname different or link to file (extension from 2 to 5 symbols)
    if (link.hostname !== window.location.hostname || /\.\w{2,5}$/.test(link.pathname)) {
      // Open as external
      external.push(link);
    } else {
      // Otherwise as internal
      internal.push(link);
    }
  });
  return { all, external, internal };
}

function getLinkFullPath(link) {
  let path = link.pathname;
  if (link.search) path += link.search;
  if (link.hash) path += link.hash;
  return path;
}

function setLinkOpenInNewTab(link) {
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer nofollow');
  link.setAttribute('improved', '');
}

function onLinkClick(e) {
  const path = getLinkFullPath(e.target);
  // Check if current link is to vue3 host page
  // If yes, do nothing to reload the page and do not try to open in current spa
  if (vue3RouteList.includes(path)) return;
  e.preventDefault();
  const { currentRoute } = router;
  // If route can be changed, push route
  if (path !== currentRoute.fullPath) {
    router.push({ path });
  // Otherwise check for hash and scroll to anchor if it exist
  } else if (currentRoute.hash) {
    const scrollOffsetTop = store.getters['view/scrollOffsetTop'];
    scrollToAnchor(currentRoute.hash, scrollOffsetTop);
  }
}

function openAsRoute(els = []) {
  els.forEach((link) => {
    if (link.hostname === window.location.hostname) {
      link.addEventListener('click', onLinkClick);
      link.setAttribute('improved', '');
    }
  });
}

function openInNewTab(els = []) {
  els.forEach(link => setLinkOpenInNewTab(link));
}

function handler(el, modifiers) {
  Vue.nextTick(() => {
    const { external, internal, all } = getLinks(el);
    // If new modifier set, open all links in new tab
    if (modifiers.new) {
      openInNewTab(all);
    } else {
      // Otherwise open external in new tab
      openInNewTab(external);
      // And rest as internal by routes
      openAsRoute(internal);
    }
  });
}

export default {
  bind(el, binding) {
    handler(el, binding.modifiers);
  },
  update(el, binding) {
    handler(el, binding.modifiers);
  },
};
